import store from '../store'
import $ from 'jquery'

import { EventBus } from '../event-bus'

const response_interceptor = function (event, xhr, settings) {
	// send the data from login to the store
	if (settings.url.includes('/Users') && settings.type.includes('POST')) {
		store.commit('auth/login', xhr.responseJSON);

	}

	return xhr.responseJSON;
}


const response_error_interceptor = function (event, jqxhr, exception, thrownError) {
	if (jqxhr.status == 200) {
		EventBus.$emit('api_success', `${jqxhr.responseText}`)
	} else {
		if (jqxhr.responseText != "") {
			EventBus.$emit('api_error', jqxhr.status ? `${jqxhr.responseText}` : 'Unknow error')
			if (!jqxhr.status) {
				store.commit('auth/logout');
			}
		} else {
			EventBus.$emit('api_error', jqxhr.status ? `${jqxhr.statusText} - ${jqxhr.status}` : 'Unknow error')
		}
	}
}
// triggred the request for the loading
$(document).bind("ajaxStart", function () {
	store.commit('api/isLoadingOn')
}).bind("ajaxStop", function () {
	store.commit('api/isLoadingOff')
});
$(document).ajaxError(response_error_interceptor);
$(document).ajaxSuccess(response_interceptor);


export default $


// WEBPACK FOOTER //
// ./src/helpers/ajax.js